import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Iniciar un nuevo ticket", -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal" }, " Debe iniciar con el código del país y no debe contener ningun símbolo (+, -, etc) ni espacios ", -1)
const _hoisted_4 = { class: "d-flex pt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Iniciar ")

import { Form } from "vee-validate";
import { socket } from "@/main";
import { ref, onMounted } from "vue";
import Modal from "@/components/Modal.vue";
import type { IChannel } from "@/callcenter/omni";
import { AuthModule } from "@/store/modules/Auth";
import Select from "@/components/Inputs/Select.vue";
import SearchClient from "@/omnichannel/components/SearchClient.vue";
import { AccountModule, IAccount } from "@/store/modules/Account";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { schemaStartTicket } from "@/store/schemas/ticket.shema";
import type {
	ModalSidebarState as ModalState,
	Options,
} from "@/types/components";
import { env } from "@/config/index";
// props

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean }
  },
  emits: ["changeModalStartTicket"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModalStartTicket", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean }


// emits


// State data
const model = ref({
	phone: "",
	channel: "",
	account: "",
	tab: "first",
});
const loading = ref(false);
const channelOptions = ref<Options<IChannel>[]>([]);
const accountOptions = ref<Options<IAccount>[]>([]);

// Methods
async function onSubmit(e: any) {
	socket.emit("START_WHATSAPP_CONVERSATION", {
		token: AuthModule.token,
		phone_number: e.phone.trim(),
		channel: e.channel,
		account: e.account,
	});
	emits("changeModalStartTicket", { show: false });
}

const channelChange = (channel: string) => {
	accountOptions.value = [];
	const opts = AccountModule.Accounts.filter(
		account => account.channels.findIndex(c => c._id === channel) >= 0
	);
	opts.forEach(accountOpt => {
		if(accountOpt.visible)
			accountOptions.value.push({
				value: accountOpt,
				label: accountOpt.name,
			});
	});
};

onMounted(() => {
	channelOptions.value = [];
	AccountModule.channels.forEach(c => {
		const found = channelOptions.value.find(o => o.value._id === c._id);
		!found &&
			(c.interface === "WHATSAPP_PUP" || c.interface === "WHATSAPP_OFFICIAL") &&
			channelOptions.value.push({
				value: c,
				label: c.name,
			});
	});
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (emits('changeModalStartTicket', { show: false }))),
    "body-classes": "py-0 pb-4",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        style: {"border-radius":"0.4375rem"},
        modelValue: model.value.tab,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.tab) = $event)),
        type: "border-card",
        stretch: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Agregar Número",
            name: "first"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Form), {
                "validation-schema": _unref(schemaStartTicket)(),
                onSubmit: _cache[1] || (_cache[1] = (e) => onSubmit(e))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(BaseInput, {
                      name: "phone",
                      label: "Número Telefónico",
                      placeholder: "Ingrese un número de teléfono",
                      "label-classes": "text-muted h5 font-weight-normal",
                      "addon-left-icon": "fas fa-phone",
                      value: model.value.phone,
                      alternative: ""
                    }, {
                      infoBlock: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(Select, {
                      name: "channel",
                      label: "Elegir un canal de whatsapp",
                      placeholder: "Seleccione un canal",
                      "label-classes": "text-muted h5 font-weight-normal",
                      "addon-left-icon": "fab fa-whatsapp",
                      value: model.value.channel,
                      "select-options": {
								options: channelOptions.value,
								noDataText: 'Sin canales',
								valueKey: '_id',
								multiple: false,
							},
                      alternative: ""
                    }, {
                      default: _withCtx((slotProp) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((slotProp.options as Options<IChannel>[]), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value?._id,
                            label: item.value?.name,
                            value: item.value?._id,
                            onClick: ($event: any) => (channelChange(item.value?._id ?? ''))
                          }, null, 8, ["label", "value", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "select-options"]),
                    _createVNode(Select, {
                      name: "account",
                      label: "Elegir una cuenta",
                      placeholder: "Seleccione una cuenta",
                      "label-classes": "text-muted h5 font-weight-normal",
                      "addon-left-icon": "fas fa-suitcase",
                      value: model.value.account,
                      "select-options": {
								options: accountOptions.value,
								noDataText: 'Seleccione un canal!!!!',
								valueKey: '_id',
								multiple: false,
							},
                      alternative: ""
                    }, {
                      default: _withCtx((slotProp) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((slotProp.options as Options<IChannel>[]), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value?._id,
                            label: item.value?.name,
                            value: item.value?._id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "select-options"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_base_button, {
                        type: "link",
                        onClick: _cache[0] || (_cache[0] = () => emits('changeModalStartTicket', { show: false }))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_base_button, {
                        type: "primary",
                        loading: loading.value,
                        "native-type": "submit",
                        class: "ml-auto"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ]),
            _: 1
          }),
          (_unref(env).requiredStartTicketAllChannels)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: "Buscar Cliente",
                name: "second"
              }, {
                default: _withCtx(() => [
                  _createVNode(SearchClient, {
                    onChangeModalStartTicket: _cache[2] || (_cache[2] = 
						() => emits('changeModalStartTicket', { show: false })
					)
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})